import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalDirective } from "ngx-bootstrap";
import { NotificationsService } from "angular2-notifications";

import { AdminService } from 'app/admin/admin.service';
import { Doctor } from "app/shared/shared.module";

@Component({
	selector: 'app-admin-area-doctors',
	templateUrl: './admin-area-doctors.component.html',
	styleUrls: ['./admin-area-doctors.component.css']
})
export class AdminAreaDoctorsComponent implements OnInit {

    @ViewChild('AddDoctorModal') public AddDoctorModal: ModalDirective;

    NewDoctor: Doctor = new Doctor();
	Doctors = [];
    constructor(private adminService: AdminService, private _notification: NotificationsService) { }

    ngOnInit() {
        this.GetDoctors();
    }

    GetDoctors() {
        this.adminService.GetDoctors().subscribe((res) => {
            this.Doctors = res;
        });
    }

    OpenAddDoctorModal() {
        this.NewDoctor = new Doctor();
        this.AddDoctorModal.show();
    };

    AddNewDoctor() {
        //this.NewDoctor.Username = this.NewDoctor.Name.split(" ").join(".").toLowerCase();
        console.log(this.NewDoctor);
        this.adminService.AddDoctor(this.NewDoctor).subscribe((res) => {
            this._notification.success("Doctor Created", "Doctor created successfully with the password '" + res.Password + "'")
            this.GetDoctors();
            this.CloseAddDoctorModal();
        });
    };

    CloseAddDoctorModal() {
        this.AddDoctorModal.hide();
    };
}



// WEBPACK FOOTER //
// ./src/app/admin/doctors/admin-area-doctors.component.ts